import { Component } from '@angular/core';
import { Bitacora } from 'src/app/model/pld/bitacora.model';
import { SweetServices } from 'src/services/sweet.services';
import { NgForm } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';
import { TransaccionesService } from 'src/services/pld/transacciones.service';
import { BitacoraCargaDatosModel } from 'src/app/model/carga/BitacoraCargaDatos';
import { DetalleMonitoreo} from 'src/app/model/pld/detalleMonitoreo.model';
import { ComunicacionService } from 'src/services/comunicacion.service';

@Component({
  selector: 'app-detail-operaciones',
  templateUrl: './detail-operaciones.component.html',
  styleUrls: ['./detail-operaciones.component.css']
})
export class DetailOperacionesComponent {
  tipoBusqueda: number = 1;
  carga: Bitacora;
  total: number;
  totalRegistros : number;
  numPage: number;
  bitacoraDatos: BitacoraCargaDatosModel;
  monitoreo: DetalleMonitoreo;
  bitacoraResultados: [];

  constructor(
      private alerta: SweetServices, 
      private bitacoraService: TransaccionesService,
      private main: AppComponent,
      private comunicacion: ComunicacionService
    ) {
    this.carga = new Bitacora();
    this.bitacoraDatos = new BitacoraCargaDatosModel();
    this.total = 0;
    this.totalRegistros = 0;
    this.numPage = 0;
    this.monitoreo = new DetalleMonitoreo();
    this.buscarBitacora();
  }


  buscarBitacora() {
    let caso = this.comunicacion.getCaso();
    let casoId = caso?.caso?.CasoId;
		if (caso && (caso.caso.AlertaTipo === 'OPERACIONES CONCESIONARIOS')) {
			this.carga.TipoBusqueda = 2
		} else {
			this.carga.TipoBusqueda = 1
		}
    this.bitacoraService.buscarOperaciones(this.carga,  casoId).subscribe(response => {
      this.main.loading = false;
      if (response == null) {
        this.alerta.AlertaError(
          'Existe un error, si persiste contacte al administrador del Sitio.'
        );
        this.bitacoraResultados = [];
        this.totalRegistros = 0;
      } else if (response.isCorrect === 'false') {
        this.carga.Pagina > 1 ? this.carga.Pagina = 1 : this.carga.Pagina--;
        this.alerta.AlertaError(response.message);
        this.bitacoraResultados = [];
        this.totalRegistros = 0;
      } else if (response.data.total === 0) {
          this.alerta.AlertaSinResultados(response.message);
          this.bitacoraResultados = [];
          this.carga.Pagina > 1 ? this.carga.Pagina = 1 : this.carga.Pagina--;
          this.totalRegistros = 0;
      } else {
        this.total = response.data.total;
        this.bitacoraResultados = response.data.info.result;
        this.totalRegistros = response.totalRegistros;
        this.numPage = Math.ceil(this.totalRegistros / 15);
      }
    }, (err) => {
      this.main.loading = false;
      this.alerta.AlertaCatch(err);
    });
  }

  paginador(value) {
    this.main.loading = true;
    if (value) { 
      this.carga.Pagina++; 
    } else { 
      this.carga.Pagina--; 
    }

    if (this.carga.Pagina >= 1) {
      this.buscarBitacora();
    }
  }

  verDetalle(bitacora: DetalleMonitoreo) {
    this.monitoreo = bitacora as DetalleMonitoreo;
  }
}
